import React, {useContext, useEffect} from 'react';
import ReactModal from 'react-modal';

import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import {ModalContext} from '../../contexts/ModalContext';
import domService from '../../services/domService';
import rumCustomEvents from '../../services/events/rumCustomEvents';
import helpers from '../../utils/helpers';
import BackButton from '../NavigationButtons/BackButton';
import CloseButton from '../NavigationButtons/CloseButton';

const AppPopup = (props) => {
    const {
        children,
        className,
        isCloseVisible = true,
        onClose,
        closeClassName,
        isBackButton,
        overlayClassName,
        isCloseActionTracked = true,
        ...restProps
    } = props;
    const NavigationButton = isBackButton ? BackButton : CloseButton;
    const {modalType} = useContext(ModalContext) || {};

    useEffect(() => {
        rumCustomEvents.recordModalAction({modalType, isVisible: true});

        return () => {
            rumCustomEvents.recordModalAction({modalType, isVisible: false});
        };
    }, []);

    const onPopupClose = (action) => {
        if (onClose) {
            helpers.runFunction(onClose);

            if (isCloseActionTracked) {
                rumCustomEvents.recordActionClick({modalType, rumActionName: awsRumActionNames.CLOSE});
            }

            if (action) {
                helpers.runFunction(action);
                return;
            }
        }
    };

    return (
        <ReactModal
            parentSelector={domService.getComponentsWrapperElement}
            className={className}
            overlayClassName={overlayClassName}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            onRequestClose={onPopupClose}
            {...restProps}
        >
            {isCloseVisible && (
                <NavigationButton
                    className={closeClassName}
                    onClick={() => onClose()}
                    isClickTracked={isCloseActionTracked}
                />
            )}
            {children}
        </ReactModal>
    );
};

export default AppPopup;
